/* =================================================================
 * Work With Slider：PC 3.2表示、SP 2.2表示
 * ================================================================= */
(function workWithSlider($){
  let slickInitialized = false;

  function initSlider() {
    if (!slickInitialized) {
      $('.work_with_slider').slick({
        slidesToShow: 3.2,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: false,
        autoplay: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2.2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2.2
            }
          }
        ]
      });
      slickInitialized = true;
      // 初期化後に少し遅延させて最初のスライドへ
      setTimeout(function() {
        $('.work_with_slider').slick('slickGoTo', 0, false);
      }, 50);
    }
  }

  $(function() {
    initSlider();

    $('.work_with__wrap .prev-arrow').on('click', function() {
      $('.work_with_slider').slick('slickPrev');
    });

    $('.work_with__wrap .next-arrow').on('click', function() {
      $('.work_with_slider').slick('slickNext');
    });
  });
})(jQuery);

/* =================================================================
 * Read More アコーディオン
 * ================================================================= */
(function($) {
    $(function() {
        $('.read_more button').on('click', function() {
            var $button = $(this);
            var $content = $button.closest('.read_more').find('.read_more__content');
            // コンテンツの開閉
            $content.slideToggle(300);
            // ボタンのactiveクラス切り替え
            $button.toggleClass('is-active');
            // ボタンテキストの切り替え（任意）
            if ($button.hasClass('is-active')) {
                $button.find('span').text('Close');
            } else {
                $button.find('span').text('Check');
            }
        });
    });
})(jQuery);

/* =================================================================
 * よくある質問 アコーディオン
 * ================================================================= */
(function($) {
  $(function() {

    // ▼ ボタンでFAQ全体を表示
    $('.faq__more').on('click', function() {
      var $btn = $(this);
      var $list = $btn.closest('.faq').find('.faq_list');

      $list.stop(true, true).slideToggle(300);
      $btn.toggleClass('is-active');
    });

    // ▼ 質問クリックでAをアコーディオン（flex表示）
    $('.faq_list').on('click', '.question', function() {
      var $q = $(this);
      var $a = $q.next('.answer');

      // 他を閉じる
      $('.answer').not($a).stop(true, true).slideUp(300);
      $('.question').not($q).removeClass('is-active');

      if ($a.is(':visible')) {
        $a.stop(true, true).slideUp(300);
        $q.removeClass('is-active');
      } else {
        $a
          .stop(true, true)
          .css('display', 'flex')
          .hide()
          .slideDown(300);

        $q.addClass('is-active');
      }
    });

  });
})(jQuery);

/* =================================================================
 * 募集要項 アコーディオン
 * ================================================================= */
(function($) {
  $(function() {
    $('.recruitment__more').on('click', function() {
      var $btn = $(this);
      var $list = $btn.closest('.recruitment').find('.table_wrap');

      $list.stop(true, true).slideToggle(300);
      $btn.toggleClass('is-active');
    });
  });
})(jQuery);


/* =================================================================
 * shop modal
 * ================================================================= */
(function($){
  $(function(){

    const $stage = $('#jpMapStage');
    const svg = document.getElementById('jpMapSvg');

    /* =========================
       modal
    ========================= */
    const $modal = $('#areaModal');
    const $title = $('#modalTitle');
    const $body  = $('#modalBody');

    function openModalFromPin(pin){
      const title  = pin.dataset.title || '';
      const image  = pin.dataset.image || '';
      const accessRaw = pin.dataset.access || '';
      const access = accessRaw.replace(/\\n/g, '<br>');

      // タイトル
      $title.text(title);

      // 中身生成
      const html = `
        <div class="storeModal">
          ${image ? `
            <div class="storeModal__thumb">
              <img src="${image}" alt="${title}">
            </div>
          ` : ''}

          <div class="storeModal__content">
            ${access ? `<p class="storeModal__access">${access}</p>` : ''}
          </div>
        </div>
      `;

      $body.html(html);

      // モーダル表示
      $modal.attr('aria-hidden', 'false');
      $('body').addClass('is-modalOpen');
    }

    // ピンクリックで開く（そのまま）
    $stage.on('click', '.jpmap__pin', function(){
      openModalFromPin(this);
    });

    // 閉じる（そのまま）
    $modal.on('click', '[data-close]', function(){
      $modal.attr('aria-hidden', 'true');
      $('body').removeClass('is-modalOpen');
    });

    // ESCで閉じる（そのまま）
    $(document).on('keydown', function(e){
      if (e.key === 'Escape' && $modal.attr('aria-hidden') === 'false') {
        $modal.attr('aria-hidden', 'true');
        $('body').removeClass('is-modalOpen');
      }
    });


    /* =========================
       svg line / arrow
    ========================= */
    function clearSvg(){
      while(svg.firstChild) svg.removeChild(svg.firstChild);
    }

    function createArrowMarker(){
      const defs = document.createElementNS('http://www.w3.org/2000/svg','defs');
      const marker = document.createElementNS('http://www.w3.org/2000/svg','marker');

      marker.setAttribute('id','arrowHead');

      // ★座標系を固定（これが重要）
      marker.setAttribute('viewBox', '0 0 10 10');

      // ★見た目のサイズだけ小さくする
      marker.setAttribute('markerWidth', '7');
      marker.setAttribute('markerHeight', '7');

      // ★線の先端に合わせる基準点（viewBox基準）
      marker.setAttribute('refX', '8');
      marker.setAttribute('refY', '5');

      marker.setAttribute('orient', 'auto');
      marker.setAttribute('markerUnits', 'strokeWidth');

      const path = document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('d','M0,0 L10,5 L0,10 z');
      path.setAttribute('fill','#ffffff');
      path.setAttribute('stroke','rgba(0,0,0,.18)');
      path.setAttribute('stroke-width','1');

      marker.appendChild(path);
      defs.appendChild(marker);
      svg.appendChild(defs);
    }


    function drawConnectors(){
      const stageRect = $stage[0].getBoundingClientRect();

      svg.setAttribute(
        'viewBox',
        `0 0 ${stageRect.width} ${stageRect.height}`
      );
      svg.setAttribute('preserveAspectRatio', 'none');

      clearSvg();
      createArrowMarker();

      const pins = $stage[0].querySelectorAll('.jpmap__pin');

      pins.forEach(pin => {
        const ax = parseFloat(pin.dataset.ax);
        const ay = parseFloat(pin.dataset.ay);
        if (Number.isNaN(ax) || Number.isNaN(ay)) return;

        const pinRect = pin.getBoundingClientRect();

        // 線の開始点（ボックス下部）
        const startX = (pinRect.left - stageRect.left) + 22;
        const startY = (pinRect.top  - stageRect.top)  + pinRect.height;

        // 線の終点（地図上の正確な地点）
        const endX = (ax / 100) * stageRect.width;
        const endY = (ay / 100) * stageRect.height;

        const line = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'line'
        );

        line.setAttribute('x1', startX);
        line.setAttribute('y1', startY);
        line.setAttribute('x2', endX);
        line.setAttribute('y2', endY);

        line.setAttribute('stroke','rgba(0,0,0,.18)');
        line.setAttribute('stroke-width','2');
        line.setAttribute('stroke-linecap','round');
        line.setAttribute('marker-end','url(#arrowHead)');

        svg.appendChild(line);
      });
    }

    // 初回 & リサイズ時
    drawConnectors();
    window.addEventListener('resize', drawConnectors);

  });
})(jQuery);